import React from 'react';

// Email capture form — front-end only for now (no backend wired yet).
export default function NotifyForm() {
  const [email, setEmail] = React.useState('');
  const [status, setStatus] = React.useState('idle'); // idle | done | error

  const onSubmit = (e) => {
    e.preventDefault();
    const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (!valid) {
      setStatus('error');
      return;
    }
    // TODO: wire to a real subscription endpoint (Mailchimp, Resend, custom API…)
    setStatus('done');
    setEmail('');
  };

  return (
    <div className="w-full max-w-md">
      <form
        onSubmit={onSubmit}
        className="flex flex-col gap-3 sm:flex-row sm:items-center"
      >
        <div className="relative flex-1">
          <input
            type="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              if (status !== 'idle') setStatus('idle');
            }}
            placeholder="Enter your email"
            aria-label="Email address"
            className="w-full rounded-full border border-white/15 bg-white/[0.04] px-5 py-3.5 text-sm text-white placeholder-white/40 outline-none transition focus:border-ember-500/60 focus:bg-white/[0.06] focus:ring-2 focus:ring-ember-500/20"
          />
        </div>
        <button
          type="submit"
          className="group relative inline-flex items-center justify-center overflow-hidden rounded-full bg-gradient-to-br from-ember-400 to-ember-600 px-7 py-3.5 text-sm font-semibold text-ink-900 shadow-ember transition-transform duration-200 hover:scale-[1.03] active:scale-95"
        >
          <span className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 to-transparent transition-transform duration-700 group-hover:translate-x-full" />
          Notify Me
        </button>
      </form>

      <div className="mt-3 h-5 text-center text-sm sm:text-left">
        {status === 'done' && (
          <span className="text-ember-300">
            🔥 You're on the list. We'll be in touch.
          </span>
        )}
        {status === 'error' && (
          <span className="text-rose-400">Please enter a valid email.</span>
        )}
      </div>
    </div>
  );
}
